import { ReactNode } from 'react';

import { ActionBar } from '@dreryk/react-components';

type MyAccountActionBarProps = {
   readonly children: ReactNode;
};

const MyAccountActionBar = (props: MyAccountActionBarProps): JSX.Element => {
   return (
      <ActionBar id={'my-account-action-bar'} testId={'myAccount'}>
         {props.children}
      </ActionBar>
   );
};

export { MyAccountActionBar };
